import ApiService from "./api.service";

class SessionService extends ApiService {
    getSession(id) {
        return this.get(`api/meeting/${id}`);
    }
    getSessionForEdit(id) {
        return this.get(`api/meeting/${id}/for-edit`);
    }
    getSessionWithPointsById(id) {
        return this.get(`api/meeting/${id}/with-points`);
    }
    getSessionsBetweenDates(date_from, date_to) {
        return this.post("api/meeting/between", { date_from, date_to });
    }
    getAllSessionsYear() {
        return this.get("api/meeting/year")
    }
    getSessionTemplate() {
        return this.get("api/meeting/templates");
    }
    getNextPreviousSessionId(sid, type) {
        return this.get(`api/meeting/next-previous/${sid}/${type}`);
    }
    update(id, data) {
        return this.post(`api/meeting/${id}`, data);
    }
    updateSessionWithAllVotings(id, data) {
        return this.post(`api/meeting/${id}/with-votings-groups`, data);
    }
    getGroups(ses) {
        return this.get(`Group/groups/${ses}`);
    }
    getPoints(id) {
        return this.post(`api/meeting/${id}/agenda-items`);
    }
    getPoint(id, sid) {
        return this.get(`api/meeting/${sid}/agenda-items/${id}`);
    }
    addPoint(id, data) {
        return this.post(`api/meeting/${id}/agenda-items-add`, data);
    }
    removePoint(id, sid) {
        return this.delete(`api/meeting/${sid}/agenda-items/${id}`);
    }
    removeFewPoints(data, sid) {
        return this.delete(`api/meeting/${sid}/agenda-items/bulk`, data);
    }
    reorderPointAttachemnt(pid, data) {
        return this.post(`api/meeting/attachments/${pid}/reorder`, data);
    }
    movePoints(id, data) {
        return this.post(`api/meeting/${id}/agenda-items/move`, data);
    }
    editPoint(id, data, sid) {
        return this.post(`api/meeting/${sid}/agenda-items/${id}`, data);
    }
    duplicatePoints(id, pid, len) {
        return this.post(`api/meeting/${id}/agenda-items/${pid}/copy/${len}`);
    }
    getPublicSessionLink(id) {
        return this.get(`api/meeting/${id}/public-link`);
    }
    getPublicSessionInfoLink(id) {
        return this.get(`api/meeting/${id}/public-info-link`);
    }
    getSessionMetadata(id) {
        return this.get(`api/meeting/${id}/metadata`);
    }
    getSessionMetadataToWord(id) {
        return this.get(`api/meeting/${id}/metadata/to-word`, { responseType: "arraybuffer" });
    }
    getExportedSessionToWord(sessionId) {
        return this.get(`api/meeting/${sessionId}/export/to-word`, { responseType: "arraybuffer" });
    }
    getExportedSessionProtocolToWord(sessionId) {
        return this.get(`api/meeting/${sessionId}/protocol/to-word`, { responseType: "arraybuffer" });
    }
    createExportedInvitationToWord(sessionId, data) {
        return this.post(`api/meeting/${sessionId}/invitation/to-word`, data, { responseType: "arraybuffer" });
    }
    copyPointsBetweenSessions(data) {
        return this.post(`api/meeting/copy-agenda-item`,data);
    }

    addSessionTemplate(data) {
        return this.post(`api/meeting/templates`, data);
    }
    updateSessionTemplate(id, data) {
        return this.post(`api/meeting/templates/${id}`, data);
    }
    saveSessionAsTemplate(id)
    {
        return this.post(`api/meeting/${id}/save-as-template`)
    }
    importAgendatItems(sessionId, data) {
        return this.post(`api/meeting/${sessionId}/agenda-items/import`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    importAgendatItemsFronText(sessionId, data) {
        return this.post(`api/meeting/${sessionId}/agenda-items/import-text`, data)
    }

    searchSession(data) {
        return this.post(`api/meeting/search`, data);
    }

    duplicateSessions(sourceSessionId, data) {
        return this.post(`api/meeting/${sourceSessionId}/duplicate`, data);
    }

    setPointIsDone(pid, sid) {
        return this.post(`api/meeting/${sid}/agenda-items/${pid}/done`)
    }

    setPointIsHide(pid, sid) {
        return this.post(`api/meeting/${sid}/agenda-items/${pid}/hide`)
    }

    setPointIsTakenOff(pid, sid) {
        return this.post(`api/meeting/${sid}/agenda-items/${pid}/taken-off`)
    }

    exportSessionVotingsToBip(sid) {
        return this.post(`api/meeting/${sid}/export-votings-to-bip`)
    }

    movePointLeft(sid, pid) {
        return this.post(`api/meeting/${sid}/agenda-items/${pid}/move-left`)
    }

    getCameraTokenSSO(sid) {
        return this.get(`api/meeting/${sid}/camera-token-sso`)
    }

    lockSelectedSession(sid) {
        return this.post(`api/meeting/${sid}/lock`)
    }

    unlockSelectedSession(sid) {
        return this.post(`api/meeting/${sid}/unlock`)
    }

    sendMeetingRegarding(data) {
        return this.post(`api/meeting/send-meeting-regarding`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    movePointToSpecyficPlace(sid, data) {
        return this.post(`api/meeting/${sid}/agenda-items/move-to-place`, data);
    }

    getSessionCodeToRecorded(sid) {
        return this.get(`api/meeting/${sid}/recorded-code`);
    }

    saveSessionAudioRecord(sessionId, data) {
        return this.post(`api/meeting/${sessionId}/audio-records`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    }

    getWordListPresence(sid) {
        return this.get(`api/meeting/${sid}/presence-list/to-word`, { responseType: "arraybuffer" })
    }

    getWordListPresenceTime(sid) {
        return this.get(`api/meeting/${sid}/presence-list-time/to-word`, { responseType: "arraybuffer" })
    }

    async getSessionNameById(sessionId) {
        try {
            let response = await this.getSessionWithPointsById(sessionId);

            if (response.status !== 200) {
                throw await Promise.reject(response);
            }
            let session = response.data;
            let sessionName = session.name;

            return sessionName;
        }
        catch {
            return `${sessionId}`;
        }
    }

    activateSession(sid) {
        return this.put(`api/meeting/${sid}/activate`)
    }

    deActivateSession(sid) {
        return this.put(`api/meeting/${sid}/deactivate`)
    }

    isSessionInInteractive(sid) {
        return this.get(`api/meeting/${sid}/is-interactive`)
    }

    getSessionAudioLink(sid) { 
        return this.get(`api/meeting/${sid}/audio-video-link`)
    }

    setSessionAudioLink(sid, data) {
        return this.post(`api/meeting/${sid}/audio-video-link`, data)
    }

    hideMultiplePoints(sid, data) {
        return this.put(`api/meeting/${sid}/hide-points`, data);
    }

    unhideMultiplePoints(sid, data) {
        return this.delete(`api/meeting/${sid}/hide-points`, data);
    }


    takenOffMultiplePoints(sid, data) {
        return this.put(`api/meeting/${sid}/taken-off-points`, data);
    }

    untakenOffMultiplePoints(sid, data) {
        return this.delete(`api/meeting/${sid}/taken-off-points`, data);
    }

    getSessionGuest(sessionId){
        return this.get(`api/meeting/${sessionId}/guests`);
    }
    addSessionGuest(sessionId, data){
        return this.post(`api/meeting/${sessionId}/guests`, data);
    }
    updateSessionGuest(sessionId, sessionGuestId, data){
        return this.post(`api/meeting/${sessionId}/guests/${sessionGuestId}`, data);
    }
}

export default new SessionService();
